import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../../assets/images/logo-sq.jpg';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Calculator from '../../../Components/calculator/Calculator';
import { safeParseHtml } from '../../../utils/safeParseHtml';

export default function ExamHeader({title,index,end,info,userExam,resetKey,setKey,review,setReview,reviewSelectedOrder,setReviewSelectedOrder}:any){
    const navigate = useNavigate();
    const [calc,setCalc] = useState(false);

    return(
        <>
        <header dir='ltr' className="d-flex align-items-center bg-dark py-1 border-bottom border-danger border-2 text-white" data-bs-theme="dark">
            <div className="pe-4">
                <img src={logo} style={{maxHeight: "70px"}} alt="logo"></img>
                <h6 className="d-none d-md-inline text-white me-4">{title}{" (Review Mode)"}</h6>
            </div>
            
            <ul className="me-auto mt-1 mb-0 ms-4 d-flex align-items-center list-unstyled overflow-scroll">

                {review ? (
                    <>
                        <li className="ms-4">
                            <button
                                onClick={() => { setReview(false); setKey(resetKey + 1); }}
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#575658"}}
                            >
                                Return
                                <FontAwesomeIcon icon="arrow-left" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button
                                onClick={() => {
                                    if (!reviewSelectedOrder) return;
                                    setReview(false);
                                    setKey(resetKey + 1);
                                    navigate(`/panel/exam/review/${userExam}/${reviewSelectedOrder}`);
                                }}
                                disabled={!reviewSelectedOrder}
                                className="btn py-2 px-3 text-center fw-light border border-secondary"
                                style={{backgroundColor:"#3A669C", opacity: reviewSelectedOrder ? 1 : 0.6}}
                            >
                                Go to Question
                                <FontAwesomeIcon icon="arrow-right" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                ) : (
                    <>
                        <li className="ms-4">
                            <button onClick={() => {window.confirm('Are you sure you want to exit?') && navigate("/panel/user-exams");setKey(resetKey + 1);} } className="btn py-2 px-3 text-center fw-light border border-secondary" style={{backgroundColor:"#694C61"}}>
                                Exit
                                <FontAwesomeIcon icon="right-from-bracket" className='d-block mx-auto'/>
                            </button>
                        </li>

                        <li className="ms-2">
                            <button className="btn py-2 px-3 text-center fw-light border border-secondary" onClick={() => setCalc(calc => !calc)} style={{backgroundColor:"#575658"}}>
                                Calc
                                <FontAwesomeIcon icon="calculator" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-4">
                            <button className="btn py-2 px-3 text-center fw-light border border-secondary" style={{backgroundColor:"#575658"}} data-bs-toggle="modal" data-bs-target="#infoModal">
                                Info
                                <FontAwesomeIcon icon="info-circle" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button className="btn py-2 px-3 text-center fw-light border border-secondary"  onClick={() => {setReview(true); setReviewSelectedOrder(index)}} style={{backgroundColor:"#575658"}}>
                                Review
                                <FontAwesomeIcon icon="sitemap" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="ms-2">
                            <button onClick={() => {navigate(`/panel/exam/review/${userExam}/${index-1}`);setKey(resetKey + 1)}} disabled={index <= 1} className={`btn py-2 px-3 text-center fw-light border border-secondary`} style={{backgroundColor:"#3A669C"}}>
                                Back
                                <FontAwesomeIcon icon="step-backward" className='d-block mx-auto'/>
                            </button>
                        </li>
                        <li className="">
                            <button 
                                onClick={() => {
                                    if (index === end) {
                                        const win = window.confirm('مرور آزمون شما به اتمام رسیده است؟');
                                        if (win) {
                                            navigate(`/panel/user-exams`);
                                            setKey(resetKey + 1);
                                        }
                                    } else {
                                        navigate(`/panel/exam/review/${userExam}/${index+1}`);
                                        setKey(resetKey + 1);
                                    }
                                }}
                                className="btn py-2 px-3 text-center fw-light border border-secondary" 
                                style={{backgroundColor:"#3A669C"}}
                            >
                                {index === end ? "Finish" : index === 0 ? "Continue" : "Next"}
                                <FontAwesomeIcon icon="step-forward" className='d-block mx-auto'/>
                            </button>
                        </li>
                    </>
                )}
            </ul>
        </header>
        <div className="modal fade" dir='ltr' id="infoModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
                <div className="modal-content">
                <div className="modal-header">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                    <h1 className="modal-title fs-5" id="exampleModalLabel">Exam Info</h1>
                </div>
                <div className="modal-body">
                    {safeParseHtml(info)}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
                </div>
            </div>
        </div>

        {calc && <Calculator close={setCalc}/>}
        </>
   )
}
